import * as React from "react";
import { connect } from "react-redux";
import idssStyle from "../../Configuration/SharedStyling";
import {
    Grid2 as Grid,
    Typography,
    Fab,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions,
    Fade,
    CircularProgress,
    Button,
    InputLabel,
    Box,
    Divider
} from "@mui/material";
import { createStyles, Theme } from '@mui/material/styles';;
import { withStyles, WithStyles } from '@mui/styles';;
import UserManagerService from "../Services/UserManagerService";
import * as validator from "validator";
import { AjaxError } from "rxjs/ajax";
import { firstValueFrom } from 'rxjs';
import {
    IGenericUserProps,
    genericMapStateToProps
} from "../../DataClasses/GenericUser";
import ListIcon from '@mui/icons-material/List';
import AddCircle from '@mui/icons-material/AddCircle';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import DoneIcon from '@mui/icons-material/Done';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import OrganizationService from "../Services/OrganizationService";
import { FormikHelpers, FormikErrors, FormikProps, Formik } from "formik";
import AlertDialog
    from "../Shared/AlertDialog";
import * as _ from 'lodash';
import * as AuthorizationPolicies from "../../Configuration/AuthorizationPolicies";
import {
    IOrgUserPayload,
    IUsersListViewStateStore,
    IAddUserForm,
    IEditUserForm,
    IEditOrganizationForm
} from "../../DataClasses/UsersData";
import Select from "react-select";
import { ISubmissionKey } from "../../DataClasses/SubmissionData";
import SubmissionsService from "../Services/SubmissionsService";
import { SeedTime } from "../../Configuration/Setting";
import { Redirect } from "react-router-dom";
import AdministrationService from "../Services/AdministrationService";
import SharedMaterialReactTable, { ISharedTableColumn } from "../Shared/MaterialReactTable";
import LoadingDataTable from "../Shared/LoadingDataTable";

const styles = (theme: Theme) => createStyles({
    ...idssStyle(theme)
});

const selectStyles = { menu: styles => ({ ...styles, zIndex: 9999 }) };

type IStylesProps = WithStyles<typeof styles>;

// VIEW
class UsersListView extends React.Component<
    IGenericUserProps & IStylesProps,
    IUsersListViewStateStore
> {
    constructor(props: IGenericUserProps & IStylesProps) {
        super(props);
        this.state = {
            userData: [],
            organizationData: [],
            isLoading: true,
            isLoadingAuditorSubmissions: false,
            filterText: "",
            errorMsg: "",
            events: {
                addUserDialogOpen: false,
                deleteUserConfirmDialogOpen: false,
                editUserDialogOpen: false,
                deleteRoleConfirmDialogOpen: false,
                editOrganizationDialogOpen: false,
                deleteOrgUserConfirmDialogOpen: false,
                deleteAllUserConfirmDialogOpen: false,
                currentlyDeletingAllUsersForOrg: false
            },
            addUser: {
                email: "",
                selectedSystemGroup: "",
                selectedRole: "",
                selectedOrgs: []
            },
            editUser: {
                email: "",
                selectedSystemGroup: "",
                selectedOrgs: [],
                selectedRole: "",
                existingRoles: []
            },
            deleteUserDialog: {
                description: "",
                title: "",
                user: ""
            },
            deleteRoleDialog: {
                description: "",
                title: "",
                user: "",
                roleInfo: ""
            },
            editOrganization: {
                organizationId: 0,
                organizationName: "",
                orgType: "",
                selectedUser: "",
                selectedRole: "",
                existingUsers: [],
                currentlySubmittingRowIndex: null,
                userSearchText: ""
            },
            editSubmissions: {
                isEditingSubmissions: false,
                userName: "",
                submissionData: [],
                origSelectedSubIndexes: [],
                selectedSubIndexes: [],
                isChangeSaved: false
            },
            deleteOrgUserDialog: {
                description: "",
                title: "",
                user: "",
                roleInfo: ""
            },
            deleteAllUserDialog: {
                description: "",
                title: ""
            },
            selectableRoles: [],
            isProcessing: false,
            isOrgLoading: false,
            redirect: false,
            auditors: []
        };
    }

    public async componentDidMount() {
        // This method runs when the component is first added to the page
        await this.RefreshModel();
        await this.GetAllAuditors();
    }

    private redirectToErrorPage() {
        return <Redirect to='/errorpage' />;
    }

    private setRedirectState() {
        this.setState({ redirect: true });
    }

    private getPrimaryUserListColumns = (): ISharedTableColumn<any>[] => {
        const { classes, user } = this.props;
        return [
            {
                accessorKey: 'Email' as any,
                header: 'Email',
                enableSorting: true,
                enableFiltering: true,
                size: 300
            },
            {
                accessorKey: 'Actions' as any,
                header: 'Actions',
                enableSorting: false,
                enableFiltering: false,
                enableColumnActions: false,
                Cell: ({ row }) => (
                    <div>
                        <EditIcon className={classes.actionIcon} onClick={() => this.ShowUserEditDialog(row.original.Email)}></EditIcon>
                    </div>
                ),
            },
            {
                accessorKey: 'Delete' as any,
                header: '',
                enableSorting: false,
                enableFiltering: false,
                enableColumnActions: false,
                Cell: ({ row }) => {
                    if (user.profile.username === row.original.Email) return null;
                    return (
                        <div>
                            <DeleteIcon className={classes.actionIcon} onClick={() => this.ShowUserDeleteDialog(row.original.Email)}></DeleteIcon>
                        </div>
                    );
                },
            },
        ];
    }

    private getPrimaryOrganizationListColumns = (): ISharedTableColumn<any>[] => {
        const { classes } = this.props;
        return [
            {
                accessorKey: 'OrgId' as any,
                header: 'Org ID',
                enableSorting: true,
                enableFiltering: true,
            },
            {
                accessorKey: 'Name' as any,
                header: 'Org Name',
                enableSorting: true,
                enableFiltering: true,
                size: 300
            },
            {
                accessorKey: 'Actions' as any,
                header: 'Actions',
                enableSorting: false,
                enableFiltering: false,
                enableColumnActions: false,
                Cell: ({ row }) => (
                    <div>
                        <EditIcon className={classes.actionIcon} onClick={() => this.ShowOrganizationEditDialog(row.original.OrgId, row.original.Name, row.original.OrgType)}></EditIcon>
                    </div>
                ),
            },
        ];
    }

    private getUserRoleColumns = (userEmail: string): ISharedTableColumn<any>[] => {
        const { classes, user } = this.props;
        return [
            {
                accessorKey: 'entityId' as any,
                header: 'ID',
                enableSorting: true,
                enableFiltering: true,
                size: 80
            },
            {
                accessorKey: 'entityName' as any,
                header: 'Org/Vendor Name',
                enableSorting: true,
                enableFiltering: true,
                size: 280
            },
            {
                accessorKey: 'roleType' as any,
                header: 'Role Type',
                enableSorting: true,
                enableFiltering: true,
            },
            {
                accessorKey: 'roleName' as any,
                header: 'Role Name',
                enableSorting: true,
                enableFiltering: true,
            },
            {
                accessorKey: 'Actions' as any,
                header: 'Actions',
                enableSorting: false,
                enableFiltering: false,
                enableColumnActions: false,
                size: 100,
                Cell: ({ row }) => {
                    if (user.profile.username === userEmail && row.original.roleName.toLowerCase().indexOf("admin") !== -1) return null;
                    return (
                        <div>
                            <DeleteIcon className={classes.actionIcon} onClick={() => this.ShowRoleDeleteDialog(row.original.roleName, row.original.roleType, row.original.entityId)}></DeleteIcon>
                        </div>
                    );
                },
            },
        ];
    }

    private getSubmissionColumns = (): ISharedTableColumn<any>[] => {
        const { classes } = this.props;
        return [
            {
                accessorKey: 'submissionId' as any,
                header: 'Sub ID',
                enableSorting: true,
                enableFiltering: true,
            },
            {
                accessorKey: 'productLine' as any,
                header: 'Product Line',
                enableSorting: true,
                enableFiltering: true,
            },
            {
                accessorKey: 'reportingProduct' as any,
                header: 'Reporting Product',
                enableSorting: true,
                enableFiltering: true,
            },
            {
                accessorKey: 'specialArea' as any,
                header: 'Special Area',
                enableSorting: true,
                enableFiltering: true,
            },
            {
                accessorKey: 'specialProject' as any,
                header: 'Special Project',
                enableSorting: true,
                enableFiltering: true,
            },
            {
                accessorKey: 'cmsContractNumber' as any,
                header: 'CMS Contract#',
                enableSorting: true,
                enableFiltering: true,
            }
        ];
    }

    private getOrgUserColumns = (roleOption: any[]): ISharedTableColumn<any>[] => {
        const { classes } = this.props;
        return [
            {
                accessorKey: 'email' as any,
                header: 'Email',
                enableSorting: true,
                enableFiltering: true,
            },
            {
                accessorKey: 'roleName' as any,
                header: 'Role',
                enableSorting: true,
                enableFiltering: true,
                Cell: ({ row }) => {
                    const rowIndex = row.index;
                    return (
                        <Select
                            options={this.getRoleOptionsPerUser(row.original.email)}
                            value={roleOption.filter(x => x.value === row.original.roleName)[0]}
                            onChange={(selectedOption) => this.handleOrgUserRoleChange({ rowData: [row.original.email, row.original.roleName], rowIndex }, selectedOption)}
                            isDisabled={rowIndex === this.state.editOrganization.currentlySubmittingRowIndex || (this.props.user.profile.username === row.original.email && row.original.roleName.toLowerCase().indexOf("admin") !== -1)}
                            /* Use a portal + elevated z-index so the menu is not clipped by table row overflow */
                            menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
                            menuPosition="fixed"
                            styles={{
                                ...selectStyles,
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                container: (base) => ({ ...base, zIndex: 10 }),
                            }}
                        />
                    );
                },
            },
            {
                accessorKey: 'submissionAccess' as any,
                header: 'Submission Access',
                enableSorting: false,
                enableFiltering: false,
                enableColumnActions: false,
                Cell: ({ row }) => {
                    return (
                        row.original.roleName.toLowerCase() === "auditor" ?
                            <Button
                                size="small"
                                variant="contained"
                                color="inherit"
                                className={classes.button}
                                startIcon={<ListIcon />}
                                onClick={() => this.btnClickManageSubmissions(row.original.email)}
                            >
                                &nbsp;Manage Submissions
                            </Button> : null
                    );
                },
            },
            {
                accessorKey: 'Actions' as any,
                header: 'Actions',
                enableSorting: false,
                enableFiltering: false,
                enableColumnActions: false,
                size: 100,
                Cell: ({ row }) => {
                    if (this.props.user.profile.username === row.original.email && row.original.roleName.toLowerCase().indexOf("admin") !== -1) return null;
                    return (
                        <div>
                            <DeleteIcon className={classes.actionIcon} onClick={() => this.ShowOrgUserDeleteDialog(row.original.email, row.original.roleName)}></DeleteIcon>
                        </div>
                    );
                },
            },
        ];
    }

    public render() {
        if (this.state.redirect) {
            return this.redirectToErrorPage();
        }
        const { classes } = this.props;

        return (
            <Grid container={true} className={classes.gridRowFlex} spacing={2}>
                <Grid size={12}>
                    <Grid container={true} spacing={2}>
                        <Grid  >
                            <Typography className={classes.submissionTitle}>
                                User Management
                            </Typography>
                        </Grid>
                        <Grid color='inherit' className={classes.flexGrow} >

                        </Grid>
                        <Grid >
                            <Fab className={classes.fab} variant="extended" color="secondary" onClick={() => this.openAddUserDialog()}>
                                <AddCircle className={classes.extendedIcon} />
                                Add User
                            </Fab>
                            <Formik<IAddUserForm>
                                initialValues={this.state.addUser}
                                enableReinitialize={true}
                                onSubmit={this.onAddUserFormSubmit}
                                validate={this.validateAddUserForm}
                            >
                                {props => this.getAddUserForm(props, classes)}
                            </Formik>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid key={1} size={6} className={classes.gridDisplay}>
                    <div className={classes.card}>
                        <Fade in={true} {...({ timeout: SeedTime })}><div>
                            <SharedMaterialReactTable
                                data={this.state.userData}
                                columns={this.getPrimaryUserListColumns()}
                                title="Users"
                                isLoading={this.state.isLoading}
                                enablePagination={true}
                                enableSorting={true}
                                enableFiltering={true}
                                enableColumnActions={true}
                                enableRowActions={false}
                                layoutMode="fixed"
                                initialState={{
                                    pagination: { pageIndex: 0, pageSize: 10 },
                                }}
                                muiPaginationProps={{
                                    rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100, 500, 1000],
                                }}
                                emptyMessage="No users found."
                            /></div></Fade>
                        <AlertDialog
                            showDialog={this.state.events.deleteUserConfirmDialogOpen}
                            title={this.state.deleteUserDialog.title}
                            description={this.state.deleteUserDialog.description}
                            button1Text="Delete User"
                            button2Text="Cancel"
                            button1Handler={this.DeleteUser}
                            button2Handler={() => this.CloseDeleteUserConfirmDialog()}
                            isButton1Clicked={this.state.isProcessing}
                        />
                        <Formik<IEditUserForm>
                            initialValues={this.state.editUser}
                            enableReinitialize={true}
                            onSubmit={this.onEditUserFormSubmit}
                            validate={this.validateEditUserForm}
                        >
                            {props => this.getEditUserForm(props, classes)}
                        </Formik>
                        <AlertDialog
                            showDialog={this.state.events.deleteRoleConfirmDialogOpen}
                            title={this.state.deleteRoleDialog.title}
                            description={this.state.deleteRoleDialog.description}
                            button1Text="Delete Role"
                            button2Text="Cancel"
                            button1Handler={this.DeleteRole}
                            button2Handler={() => this.CloseDeleteRoleConfirmDialog()}
                            isButton1Clicked={this.state.isProcessing}
                        />
                    </div>
                </Grid>
                <Grid key={2} size={6} className={classes.gridDisplay}>
                    <div className={classes.card}>
                        <Fade in={true} {...({ timeout: SeedTime * 2 })}><div>
                            <SharedMaterialReactTable
                                data={this.state.organizationData}
                                columns={this.getPrimaryOrganizationListColumns()}
                                title="Organizations"
                                isLoading={this.state.isLoading}
                                enablePagination={true}
                                enableSorting={true}
                                enableFiltering={true}
                                enableColumnActions={true}
                                enableRowActions={false}
                                layoutMode="fixed"
                                initialState={{
                                    pagination: { pageIndex: 0, pageSize: 10 },
                                }}
                                muiPaginationProps={{
                                    rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100, 500, 1000],
                                }}
                                emptyMessage="No organizations found."
                            /></div></Fade>
                        <Formik<IEditOrganizationForm>
                            initialValues={this.state.editOrganization}
                            enableReinitialize={true}
                            onSubmit={this.onEditOrganizationFormSubmit}
                            validate={this.validateEditOrganizationForm}
                        >
                            {props => this.getEditOrganizationForm(props, classes)}
                        </Formik>
                        <AlertDialog
                            showDialog={this.state.events.deleteOrgUserConfirmDialogOpen}
                            title={this.state.deleteOrgUserDialog.title}
                            description={this.state.deleteOrgUserDialog.description}
                            button1Text="Remove User"
                            button2Text="Cancel"
                            button1Handler={this.DeleteOrgUser}
                            button2Handler={() => this.CloseDeleteOrgUserConfirmDialog()}
                            isButton1Clicked={this.state.isProcessing}
                        />
                        <AlertDialog
                            showDialog={this.state.events.deleteAllUserConfirmDialogOpen}
                            title={this.state.deleteAllUserDialog.title}
                            description={this.state.deleteAllUserDialog.description}
                            button1Text="Remove All"
                            button2Text="Cancel"
                            button1Handler={this.DeleteAllOrgUsers}
                            button2Handler={() => this.CloseDeleteUserConfirmDialog()}
                            isButton1Clicked={this.state.isProcessing}
                        />
                    </div>
                </Grid>
            </Grid>
        );
    }

    private async RefreshModel() {
        this.setState({ isLoading: true });
        const userRetVal = await firstValueFrom(
            UserManagerService.GetManagableUsers$(this.props.user)
        );
        const orgRetVal = await firstValueFrom(
            OrganizationService.GetManagableOrganizationsAndVendors$(this.props.user)
        );

        if (userRetVal instanceof AjaxError || orgRetVal instanceof AjaxError || !userRetVal || !orgRetVal) {
            this.setRedirectState();
        }
        else {
            const userData = userRetVal.map(item => ({ Email: item }));
            const orgData = orgRetVal.map(item => ({
                OrgId: item.orgId,
                Name: item.orgName,
                OrgType: item.orgType
            }));
            this.setState({
                userData: userData,
                organizationData: orgData
            });

            this.setState({ isLoading: false });
        }
    }

    private openAddUserDialog = () => {
        this.setState({
            events: {
                ...this.state.events,
                addUserDialogOpen: true
            }
        });
    }

    private closeAddUserDialog = () => {
        this.setState({
            events: {
                ...this.state.events,
                addUserDialogOpen: false
            },
            addUser: {
                email: "",
                selectedSystemGroup: "",
                selectedRole: "",
                selectedOrgs: []
            }
        });
    }

    private getAddUserForm = (formikProps: FormikProps<IAddUserForm>, classes: any): JSX.Element => {
        const {
            handleSubmit,
            handleReset,
            handleBlur,
            touched,
            errors,
            values,
            isSubmitting,
            submitForm
        } = formikProps;

        const orgOption = (values.selectedSystemGroup && values.selectedSystemGroup.value !== "") ?
            this.state.organizationData.filter(x => x.OrgType === values.selectedSystemGroup.value).map(m => ({
                label: m.OrgId + "-" + m.Name,
                value: m.OrgId
            })) : [];

        const roleOption = this.state.selectableRoles.map(m => ({ value: m, label: m }));

        return (
            <div>
                <form onSubmit={handleSubmit}>
                    <Dialog open={this.state.events.addUserDialogOpen} onClose={handleReset} classes={{ paper: classes.dialogM }} >
                        <DialogTitle id="max-width-dialog-title">
                            Add New User
                        </DialogTitle>
                        <Divider />
                        <DialogContent>
                            <Grid size={10} key="userRoleListInputsAdd" className={classes.flexGrow + " " + classes.fullWidth}>
                                <Box flexGrow={1} className={classes.defaultMargin}>
                                    <InputLabel shrink>Email</InputLabel>
                                    <TextField
                                        autoFocus={false}
                                        fullWidth={true}
                                        name="email"
                                        margin="dense"
                                        type="text"
                                        required={true}
                                        error={errors.email && touched.email}
                                        helperText={
                                            errors.email && touched.email
                                                ? errors.email
                                                : undefined
                                        }
                                        onChange={this.onChangeAddNewUserEmail.bind(this)}
                                        onBlur={handleBlur}
                                        value={values.email}
                                        disabled={isSubmitting}
                                    />
                                </Box>
                                <Box flexGrow={1} className={classes.defaultMargin}>
                                    <InputLabel shrink>Select System Group</InputLabel>
                                    <Select
                                        options={this.GetSysGroupOptions()}
                                        placeholder="Select a System Group"
                                        value={values.selectedSystemGroup}
                                        onChange={this.onChangeAddNewUserSysGroup.bind(this)}
                                        isClearable
                                        styles={selectStyles}
                                    />
                                </Box>
                                {this.state.addUser.selectedSystemGroup === "" ? <br /> :
                                    <div>
                                        <Box flexGrow={1} className={classes.defaultMargin}>
                                            <InputLabel shrink>Select Role</InputLabel>
                                            <Select
                                                options={!this.isSelectedUserAuditor(this.state.addUser.email) ? roleOption.filter(r => r.value.toLowerCase() !== "auditor") : roleOption}
                                                placeholder="Select a Role"
                                                value={values.selectedRole}
                                                onChange={this.onChangeAddNewUserSelectedRole.bind(this)}
                                                isClearable
                                                styles={selectStyles}
                                            />
                                            {touched.selectedRole && (typeof errors.selectedRole === 'string' ? errors.selectedRole : Array.isArray(errors.selectedRole) ? errors.selectedRole.join(', ') : '')}
                                        </Box>
                                        <Box flexGrow={1} className={classes.defaultMargin}>
                                            <InputLabel shrink>Select {this.state.addUser.selectedSystemGroup === null ? "Organization" : this.state.addUser.selectedSystemGroup.value}(s)</InputLabel>
                                            <Select
                                                options={orgOption}
                                                placeholder={"Search and Select..."}
                                                isMulti
                                                value={values.selectedOrgs}
                                                onChange={this.selectedOrgsChange4AddNewUser.bind(this)}
                                                styles={selectStyles}
                                                maxMenuHeight={150}
                                            />
                                            {touched.selectedOrgs && (typeof errors.selectedOrgs === 'string' ? errors.selectedOrgs : Array.isArray(errors.selectedOrgs) ? errors.selectedOrgs.join(', ') : '')}
                                        </Box>
                                    </div>
                                }
                            </Grid>
                        </DialogContent>
                        <Divider />
                        <DialogActions>
                            {this.showProgress()}
                            <Fab className={classes.fab} size="medium" variant="extended" color="secondary" onClick={submitForm}
                                disabled={!(!validator.isEmpty(values.email) && validator.isEmail(values.email) && values.selectedSystemGroup !== "" && values.selectedRole !== "" && values.selectedOrgs.length > 0) || this.state.isProcessing}>
                                <AddCircle className={classes.extendedIcon} />
                                Add User
                            </Fab>
                            <Button
                                className={classes.disabledButton}
                                onClick={() => this.closeAddUserDialog()}
                                disabled={isSubmitting}
                            >
                                Cancel
                            </Button>
                        </DialogActions>
                    </Dialog>
                </form>
            </div>
        );
    };

    private selectedOrgsChange4AddNewUser(newValue) {
        this.setState({
            addUser: {
                ...this.state.addUser,
                selectedOrgs: newValue
            }
        })
    }
    private onChangeAddNewUserSelectedRole(newValue) {
        this.setState({
            addUser: {
                ...this.state.addUser,
                selectedRole: newValue === null ? "" : newValue
            }
        })
    }

    async onChangeAddNewUserEmail(e) {
        if (this.state.addUser.selectedRole && this.state.addUser.selectedRole.value.toLowerCase() === "auditor" && !this.isSelectedUserAuditor(e.target.value)) {
            this.setState({
                addUser: {
                    ...this.state.addUser,
                    selectedRole: "",
                    email: e.target.value
                }
            })
        }
        else {
            this.setState({
                addUser: {
                    ...this.state.addUser,
                    email: e.target.value
                }
            });
        }
    }
    async onChangeAddNewUserSysGroup(newValue) {
        this.setState({
            addUser: {
                ...this.state.addUser,
                selectedSystemGroup: newValue === null ? "" : newValue,
                selectedRole: "",
                selectedOrgs: []
            }
        });
        if (newValue !== null && newValue !== "") {
            this.refreshSelectableRoles(newValue.value);
        }
    }

    private GetSysGroupOptions() {
        const sysGroupDup = this.state.organizationData.map(m => m.OrgType);
        const sysGroupOption = sysGroupDup.filter((n, i) => sysGroupDup.indexOf(n) === i).map(m => ({ value: m, label: m }));
        return sysGroupOption;
    }

    private validateAddUserForm = (values: IAddUserForm): FormikErrors<IAddUserForm> => {
        const errors: FormikErrors<IAddUserForm> = {};

        // EMAIL
        //1. Require
        // 2. Max length = 255
        // 3. Valid
        if (validator.isEmpty(values.email)) {
            errors.email = "Required";
        } else if (!validator.isLength(values.email, { min: 1, max: 75 })) {
            errors.email = "Email can be no longer than 75 characters";
        } else if (!validator.isEmail(values.email)) {
            errors.email = "Email is not in a valid format";
        }

        if (!values.selectedOrgs || values.selectedOrgs.length === 0) {
            errors.selectedOrgs = "Please select an organization.";
        }

        return errors;
    };

    private onAddUserFormSubmit = async (
        values: IAddUserForm,
        formikHelpers: FormikHelpers<IAddUserForm>
    ): Promise<void> => {
        const { setSubmitting } = formikHelpers;
        try {
            this.setProcessingState(true);
            const retval = await firstValueFrom(
                UserManagerService.AddUserToRoles$(
                    this.props.user,
                    values.email,
                    values.selectedSystemGroup.value.toLowerCase(),
                    values.selectedRole.value,
                    values.selectedOrgs && values.selectedOrgs.length > 0
                        ? values.selectedOrgs.map(x => x.value).join(",")
                        : "",
                    "",
                    true
                )
            );
            if (retval instanceof AjaxError || !retval) {
                this.setRedirectState();
            }
            else {
                this.closeAddUserDialog();
            }
        } catch (ex) {
        } finally {
            setSubmitting(false);
            this.RefreshModel();
            this.setProcessingState(false);
        }
    }

    private setProcessingState = (value: boolean) => {
        this.setState({ isProcessing: value });
    }

    private showProgress = () => {
        return <> {this.state.isProcessing ? <span style={{ paddingTop: '10px' }}><CircularProgress color="primary" size={22} /></span> : null} </>
    }
    private RefreshRolesForUser = async (userEmail) => {
        try {
            const userRetVal = await firstValueFrom(
                UserManagerService.GetManagableRolesForUser$(
                    this.props.user,
                    userEmail
                )
            );

            if (userRetVal instanceof AjaxError || !userRetVal) {
                this.setRedirectState();
                return;
            }

            const userRoles = _.flatten(
                userRetVal.map(item => [item])
            );

            this.setState(prev => ({
                editUser: {
                    ...prev.editUser,
                    existingRoles: userRoles
                }
            }));
        } catch (error) {
            console.error("Failed to refresh roles for user", userEmail, error);
            this.setRedirectState();
        }
    }

    private GetAllAuditors = async () => {
        const retVal = await firstValueFrom(
            AdministrationService.GetAllAuditors$(this.props.user)
        );
        if (retVal instanceof AjaxError || !retVal) {
            this.setRedirectState();
        }
        else {
            this.setState({
                auditors: retVal
            });
        }
    }

    
    private getRoleOptionsPerUser = (userEmail: string): { value: string; label: string }[] => {
        const roleOptions = this.state.selectableRoles
            .filter(role => !!role) 
            .map(role => ({ value: role, label: role }));

        const excludedRoles = this.isSelectedUserAuditor(userEmail)
            ? ["orguser", "orgadmin", "signer"]
            : ["auditor"];

        return roleOptions.filter(({ value }) => !excludedRoles.includes(value.toLowerCase()));
    }

    private isSelectedUserAuditor = (userEmail: string) => {
        var auditors = this.state.auditors;
        return auditors.some(a => a.toLowerCase() === userEmail.toLowerCase());
    }

    private ShowUserEditDialog = async (userEmail) => {
        await this.RefreshRolesForUser(userEmail);
        this.setState(prev =>({
            events: {
                ...prev.events,
                editUserDialogOpen: true
            },
            editUser: {
                ...prev.editUser,
                email: userEmail,
                selectedOrgs: [],
                selectedRole: ""
            }
        }));
    }

    private closeEditUserDialog = () => {
        this.setState({
            events: {
                ...this.state.events,
                editUserDialogOpen: false
            },
            editUser: {
                email: "",
                selectedSystemGroup: "",
                selectedOrgs: [],
                selectedRole: "",
                existingRoles: []
            },
            selectableRoles: []
        });
    }

    private getEditUserForm = (formikProps: FormikProps<IEditUserForm>, classes: any): JSX.Element => {
        const {
            handleSubmit,
            handleReset,
            errors,
            touched,
            values,
            isSubmitting,
        } = formikProps;


        const orgOption = (values.selectedSystemGroup && values.selectedSystemGroup.value !== "") ?
            this.state.organizationData.filter(x => x.OrgType === values.selectedSystemGroup.value).map(m => ({
                label: m.OrgId + "-" + m.Name,
                value: m.OrgId
            })) : [];
        
        return (
            <div>
                <form onSubmit={handleSubmit}>
                    <Dialog open={this.state.events.editUserDialogOpen} onClose={handleReset} classes={{ paper: classes.dialogM }} >
                        <DialogTitle id="max-width-dialog-title">
                            Edit: {values.email}
                        </DialogTitle>
                        <Divider />
                        <DialogContent>
                            <Grid size={12} key="userRoleListInputsEdit" className={classes.flexGrow + " " + classes.fullWidth}>
                                <Typography variant='h6' color='primary' className={classes.tabTitle}>
                                    Add Role
                                </Typography>
                                <Box flexGrow={1} className={classes.defaultMargin}>
                                    <InputLabel shrink>Select System Group</InputLabel>
                                    <Select
                                        options={this.GetSysGroupOptions()}
                                        placeholder="Select a System Group to Start Adding Role"
                                        value={values.selectedSystemGroup}
                                        onChange={this.onChangeAddRoleSysGroup.bind(this)}
                                        isClearable
                                        styles={selectStyles}
                                    />
                                </Box>
                                {this.state.editUser.selectedSystemGroup === "" ? <br /> :
                                    <div>
                                        <Box flexGrow={1} className={classes.defaultMargin}>
                                            <InputLabel shrink>Select Role</InputLabel>
                                            <Select
                                                options={this.getRoleOptionsPerUser(this.state.editUser.email)}
                                                placeholder="Select a Role"
                                                value={values.selectedRole}
                                                onChange={this.onChangeAddRoleSelectedRole.bind(this)}
                                                isClearable
                                                styles={selectStyles}
                                            />
                                            {touched.selectedRole && (typeof errors.selectedRole === 'string' ? errors.selectedRole : Array.isArray(errors.selectedRole) ? errors.selectedRole.join(', ') : '')}
                                        </Box>
                                        <Box flexGrow={1} className={classes.defaultMargin}>
                                            <InputLabel shrink>Select {this.state.editUser.selectedSystemGroup === null ? "Organization" : this.state.editUser.selectedSystemGroup.value}(s)</InputLabel>
                                            <Select
                                                options={orgOption}
                                                placeholder={"Search and Select..."}
                                                isMulti
                                                value={values.selectedOrgs}
                                                onChange={this.selectedOrgsChange4AddRole.bind(this)}
                                                styles={selectStyles}
                                                maxMenuHeight={150}
                                            />
                                            {touched.selectedOrgs && (typeof errors.selectedOrgs === 'string' ? errors.selectedOrgs : Array.isArray(errors.selectedOrgs) ? errors.selectedOrgs.join(', ') : '')}
                                        </Box>
                                        <Box>
                                            <Fab className={classes.fab} variant="extended" color="secondary" onClick={this.onEditUserFormSubmit} disabled={!(values.selectedSystemGroup !== "" && values.selectedRole !== "" && values.selectedOrgs !== null && values.selectedOrgs.length > 0) || this.state.isProcessing}>
                                                <AddCircle className={classes.extendedIcon} />
                                                Add Role
                                            </Fab>
                                            {this.showProgress()}
                                        </Box>
                                    </div>
                                }
                            </Grid>
                            <br />
                            <Grid size={12} key="userRoleListGrid">
                                <div className={classes.card}>
                                    <SharedMaterialReactTable
                                        data={values.existingRoles}
                                        columns={this.getUserRoleColumns(values.email)}
                                        title= "User Roles"
                                        isLoading={false}
                                        enablePagination={true}
                                        enableSorting={true}
                                        enableFiltering={true}
                                        enableColumnActions={true}
                                        enableRowActions={false}
                                        layoutMode="fixed"
                                        initialState={{
                                            pagination: { pageIndex: 0, pageSize: 10 },
                                        }}
                                        muiPaginationProps={{
                                            rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100, 500, 1000],
                                        }}
                                        emptyMessage="No roles found."
                                    />
                                </div>
                            </Grid>

                        </DialogContent>
                        <Divider />
                        <DialogActions>
                            <Button
                                onClick={() => this.closeEditUserDialog()}
                                disabled={isSubmitting}
                            >
                                ClOSE
                            </Button>
                        </DialogActions>
                    </Dialog>
                </form>
            </div>
        );
    };

    async onChangeAddRoleSysGroup(newValue) {
        this.setState({
            editUser: {
                ...this.state.editUser,
                selectedSystemGroup: newValue === null ? "" : newValue,
                selectedRole: "",
                selectedOrgs: []
            }
        });
        if (newValue !== null && newValue !== "") {
            this.refreshSelectableRoles(newValue.value);
        }
    }
    async refreshSelectableRoles(sysGroup: string) {
        const rolesRetval = await firstValueFrom(
            UserManagerService.GetAllRolesPerSysGroupEditUser$(
                this.props.user,
                sysGroup,
                this.state.editUser.email
            )
        );
        if (rolesRetval instanceof AjaxError || !rolesRetval) {
            this.setRedirectState();
        } else {
            this.setState({ selectableRoles: rolesRetval });
        }
    }

    onChangeAddRoleSelectedRole(newValue) {
        this.setState({
            editUser: {
                ...this.state.editUser,
                selectedRole: newValue === null ? "" : newValue
            }
        });
    }
    selectedOrgsChange4AddRole(newValue) {
        this.setState({
            editUser: {
                ...this.state.editUser,
                selectedOrgs: newValue
            }
        });
    }
    private validateEditUserForm = (values: IEditUserForm): FormikErrors<IEditUserForm> => {
        const errors: FormikErrors<IEditUserForm> = {};

        if (validator.isEmpty(values.email)) {
            errors.email = "Required";
        }

        if (!values.selectedOrgs || values.selectedOrgs.length === 0) {
            errors.selectedOrgs = "Please select an organization.";
        }

        if (validator.isEmpty(values.selectedRole.value)) {
            errors.selectedRole = "Required";
        }

        return errors;
    };

    onEditUserFormSubmit = async () => {
        try {
            this.setProcessingState(true);
            const response = await firstValueFrom(
                UserManagerService.AddUserToRoles$(
                    this.props.user,
                    this.state.editUser.email,
                    this.state.editUser.selectedSystemGroup.value.toLowerCase(),
                    this.state.editUser.selectedRole.value,
                    this.state.editUser.selectedOrgs && this.state.editUser.selectedOrgs.length > 0
                        ? this.state.editUser.selectedOrgs.map(x => x.value).join(",")
                        : "",
                    "",
                    false
                )
            );
            if (response instanceof AjaxError || !response) {
                this.setRedirectState();
            } else {
                await this.RefreshRolesForUser(this.state.editUser.email);
                this.setState(prev => ({
                    editUser: {
                        ...prev.editUser,
                        selectedSystemGroup: "",
                        selectedOrgs: [],
                        selectedRole: ""
                    }
                }));
            }
        } catch (ex) {
            console.error("Failed to submit edit user form", ex);
            this.setRedirectState();
        } finally {
            this.setProcessingState(false);
        }
    };

    private ShowUserDeleteDialog = (userEmail) => {
        this.setState({
            events: {
                ...this.state.events,
                deleteUserConfirmDialogOpen: true
            },
            deleteUserDialog: {
                title: "Delete User " + userEmail + "?",
                description: "Are you sure you'd like to delete User " + userEmail + "?",
                user: userEmail
            }
        });
    }

    private CloseDeleteUserConfirmDialog = () => {
        this.setState({
            events: {
                ...this.state.events,
                deleteUserConfirmDialogOpen: false
            }
        });
    }

    private DeleteUser = async () => {
        try {
            this.setProcessingState(true);
            const deleteResp = await firstValueFrom(
                UserManagerService.DeleteManagableUserAccess$(
                    this.props.user,
                    this.state.deleteUserDialog.user
                )
            );

            if (deleteResp instanceof AjaxError || !deleteResp) {
                this.setRedirectState();
            }
            else {
                const userRetVal = await firstValueFrom(
                    UserManagerService.GetManagableUsers$(this.props.user)
                );
                const userData = userRetVal.map(item => ({ Email: item }));
                this.setState({
                    userData: userData
                });
                this.CloseDeleteUserConfirmDialog();
            }
        } catch (ex) {
        } finally {
            this.setProcessingState(false);
        }
    }

    private ShowRoleDeleteDialog = (roleName, roleType, entityId) => {
        this.setState({
            events: {
                ...this.state.events,
                deleteRoleConfirmDialogOpen: true
            },
            deleteRoleDialog: {
                title: `Delete Role ${roleName}?`,
                description: `Are you sure you want to delete ${roleName} role for ${this.state.editUser.email}?`,
                user: this.state.editUser.email,
                roleInfo: entityId + "," + roleType + "," + roleName
            }
        });
    }

    private DeleteRole = async () => {
        try {
            this.setProcessingState(true);
            const deleteResp = await firstValueFrom(
                UserManagerService.DeleteUserRole$(
                    this.props.user,
                    this.state.deleteRoleDialog.user,
                    this.state.deleteRoleDialog.roleInfo
                )
            );

            if (deleteResp instanceof AjaxError || !deleteResp) {
                this.setRedirectState();
            }
            else {
                await this.RefreshRolesForUser(this.state.deleteRoleDialog.user);
                this.CloseDeleteRoleConfirmDialog();
            }
        } catch (ex) {
        } finally {
            this.setProcessingState(false);
        }
    }

    private CloseDeleteRoleConfirmDialog = () => {
        this.setState({
            events: {
                ...this.state.events,
                deleteRoleConfirmDialogOpen: false
            }
        });
    }

    private ShowOrganizationEditDialog = async (organizationId, organizationName, orgType) => {
        this.setState({
            events: {
                ...this.state.events,
                editOrganizationDialogOpen: true
            }
        });

        this.setState({ isOrgLoading: true });
        try {
            await this.RefreshUsersForOrganization(organizationId);

            this.setState(prev =>({
                editOrganization: {
                    ...prev.editOrganization,
                    organizationId: organizationId,
                    organizationName: organizationName,
                    orgType: orgType,
                    selectedUser: ""
                }
            }));

            this.refreshSelectableRoles(orgType);
        } catch (ex) {
        } finally {
            this.setState({ isOrgLoading: false });
        }
    }

    private closeEditOrganizationDialog = () => {
        //reset params for submissions screen
        this.backToOrgUsersList();
        this.setState({
            events: {
                ...this.state.events,
                editOrganizationDialogOpen: false
            }
        });
    }

    private getEditOrganizationForm = (formikProps: FormikProps<IEditOrganizationForm>, classes: any): JSX.Element => {
        const {
            handleSubmit,
            handleReset,
            values,
            isSubmitting
        } = formikProps;

        const userOption = this.state.userData.map(user => ({
            label: user.Email,
            value: user.Email
        }));

        const roleOption = this.state.selectableRoles.map(m => ({ value: m, label: m }));

        return (
            <div>
                <form onSubmit={handleSubmit}>
                    <Dialog classes={{ paper: classes.dialog7080 }}
                        open={this.state.events.editOrganizationDialogOpen}
                        onClose={handleReset}>
                        {this.state.isOrgLoading ? null : <DialogTitle id="max-width-dialog-title">Edit: {values.organizationName}</DialogTitle>}
                        <Divider />
                        {this.state.editSubmissions.isEditingSubmissions ?
                            <DialogContent>
                                <Typography variant="button" color='primary' className={classes.tabTitle}>
                                    Manage Submissions Access for Auditor: {this.state.editSubmissions.userName}
                                </Typography>
                                <SharedMaterialReactTable
                                    data={this.state.editSubmissions.submissionData}
                                    columns={this.getSubmissionColumns()}
                                    title="Available Submissions"
                                    isLoading={this.state.isLoadingAuditorSubmissions}
                                    enablePagination={true}
                                    enableSorting={true}
                                    enableFiltering={true}
                                    enableColumnActions={true}
                                    enableRowActions={false}
                                    enableRowSelection={true}
                                    enableMultiRowSelection={true}
                                    rowSelection={this.state.editSubmissions.selectedSubIndexes.reduce((acc, index) => {
                                        acc[index] = true;
                                        return acc;
                                    }, {})}
                                    onRowSelectionChange={(updatedSelection) => {
                                        const selectedIndexes = Object.keys(updatedSelection)
                                            .filter(key => updatedSelection[key])
                                            .map(key => parseInt(key));
                                        this.setState({ editSubmissions: { ...this.state.editSubmissions, selectedSubIndexes: selectedIndexes } });
                                    }}
                                    initialState={{
                                        pagination: { pageIndex: 0, pageSize: 10 },
                                    }}
                                    muiPaginationProps={{
                                        rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100, 500, 1000],
                                    }}
                                    emptyMessage="No submissions found."
                                />
                            </DialogContent>
                            :
                            <DialogContent>
                                {this.state.isOrgLoading ? <LoadingDataTable titleText="*"></LoadingDataTable> : <>
                                    <Grid size={12} key="orgUserListInputs" className={classes.flexGrow + " " + classes.fullWidth}>
                                        <Typography variant='h6' color='primary' className={classes.tabTitle}>
                                            Add User
                                        </Typography>
                                        <Box flexGrow={1} className={classes.defaultMargin}>
                                            <InputLabel shrink>Select User</InputLabel>
                                            <Select
                                                options={userOption}
                                                placeholder="Select an Email Account to Start Adding User"
                                                value={values.selectedUser}
                                                onChange={this.onChangeSelectUserToEntity.bind(this)}
                                                isClearable
                                                styles={selectStyles}
                                            />
                                        </Box>
                                        {this.state.editOrganization.selectedUser === "" ? <br /> :
                                            <div>
                                                <Box flexGrow={1} className={classes.defaultMargin}>
                                                    <InputLabel shrink>Select Role</InputLabel>
                                                    <Select
                                                        options={this.getRoleOptionsPerUser(this.state.editOrganization.selectedUser.value)}
                                                        placeholder="Select a Role"
                                                        value={values.selectedRole}
                                                        onChange={this.onChangeSelectRoleToEntityUser.bind(this)}
                                                        isClearable
                                                        styles={selectStyles}
                                                    />
                                                </Box>
                                                <Box>
                                                    <Fab className={classes.fab} variant="extended" color="secondary" onClick={this.onEditOrganizationFormSubmit} disabled={values.selectedUser === "" || values.selectedRole === "" || this.state.isProcessing}>
                                                        <AddCircle className={classes.extendedIcon} />
                                                        Add User
                                                    </Fab>
                                                    {this.showProgress()}
                                                </Box>
                                            </div>
                                        }
                                    </Grid>
                                    <br />
                                    <Grid size={12} key="orgUsersListGrid">
                                        <div className={classes.card}>
                                            <SharedMaterialReactTable
                                                data={values.existingUsers}
                                                columns={this.getOrgUserColumns(roleOption)}
                                                title="Assigned Users"
                                                isLoading={false}
                                                enablePagination={true}
                                                enableSorting={true}
                                                enableFiltering={true}
                                                enableColumnActions={true}
                                                enableRowActions={false}
                                                layoutMode="fixed"
                                                enableDownloadCsv={true}
                                                downloadFileName={`Users_${values.organizationName}`}
                                                initialState={{
                                                    pagination: { pageIndex: 0, pageSize: 10 },
                                                }}
                                                muiPaginationProps={{
                                                    rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100, 500, 1000],
                                                }}
                                                emptyMessage="No assigned users found."
                                            />
                                            {AuthorizationPolicies.IsGlobalAdmin(this.props.user) && values.existingUsers.length > 0 &&
                                                <Box>
                                                    <Fab className={classes.fab} variant="extended" color="secondary" onClick={this.ShowAllUserDeleteDialog} disabled={this.state.events.currentlyDeletingAllUsersForOrg}>
                                                        <DeleteIcon className={classes.extendedIcon} />
                                                        Delete All Users
                                                    </Fab>
                                                    <Fade
                                                        in={this.state.events.currentlyDeletingAllUsersForOrg}
                                                        style={{ transitionDelay: this.state.events.currentlyDeletingAllUsersForOrg ? "800ms" : "0ms" }}
                                                        unmountOnExit={true}
                                                    >
                                                        <CircularProgress color="secondary" size={20} />
                                                    </Fade>

                                                </Box>
                                            }
                                        </div>

                                    </Grid>
                                </>}
                            </DialogContent>
                        }
                        <Divider />
                        <DialogActions>
                            {this.state.editSubmissions.isEditingSubmissions ?
                                <div>
                                    <Button
                                        className={classes.disabledButton}
                                        startIcon={<SkipPreviousIcon />}
                                        onClick={() => this.backToOrgUsersList()}
                                    >
                                        BACK TO ORG USERS LIST {this.isSubmissionTouched() ? ' WITHOUT SAVING' : null}
                                    </Button>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    {this.state.editSubmissions.selectedSubIndexes.length < 1 ?
                                        <Fab className={classes.fab} variant="extended" size="medium" color="secondary" onClick={this.DeleteZeroSubAuditor.bind(this)} disabled={!this.isSubmissionTouched()} >
                                            <DeleteIcon className={classes.extendedIcon} />
                                            Remove User's Auditor Role
                                        </Fab>
                                        :
                                        (this.state.editSubmissions.isChangeSaved && !this.isSubmissionTouched() ?
                                            <Fab className={classes.fabGreen} variant="extended" size="medium" >
                                                <DoneIcon className={classes.extendedIcon} />
                                                Change Saved
                                            </Fab>
                                            :
                                            <Fab className={classes.fab} variant="extended" size="medium" color="secondary" onClick={this.SaveSubmissionChange.bind(this)} disabled={!this.isSubmissionTouched()} >
                                                <SaveOutlinedIcon className={classes.extendedIcon} />
                                                Save Changes
                                            </Fab>
                                        )
                                    }
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </div>
                                : null
                            }
                            <Button
                                onClick={() => this.closeEditOrganizationDialog()}
                                disabled={isSubmitting}
                            >
                                CLOSE {this.isSubmissionTouched() ? ' WITHOUT SAVING' : null}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </form>
            </div>
        );
    };
    private async DeleteZeroSubAuditor() {
        if (this.state.editSubmissions.selectedSubIndexes === null || this.state.editSubmissions.selectedSubIndexes.length < 1) {
            const deleteResp = await firstValueFrom(
                UserManagerService.DeleteUserRole$(
                    this.props.user,
                    this.state.editSubmissions.userName,
                    this.state.editOrganization.organizationId.toString() + "," + this.state.editOrganization.orgType.toLowerCase() + ",auditor"
                )
            );

            if (deleteResp instanceof AjaxError || !deleteResp) {
                this.setRedirectState();
            }
            else {
                this.backToOrgUsersList();
                this.RefreshUsersForOrganization(this.state.editOrganization.organizationId);
            }
        }
    }

    private async SaveSubmissionChange() {
        if (this.state.editSubmissions.selectedSubIndexes === null || this.state.editSubmissions.selectedSubIndexes.length < 1) {
            //do nothing - this is handled by delete ZeroSubAuditor
        }
        else {
            const selectedSubs: number[] = this.state.editSubmissions.selectedSubIndexes.map(x => {
                return this.state.editSubmissions.submissionData[x] === null ? -1 : this.state.editSubmissions.submissionData[x].submissionId;
            });
            const response = await firstValueFrom(
                UserManagerService.UpdateSubUserEntities$(
                    this.props.user,
                    this.state.editSubmissions.userName,
                    this.state.editOrganization.organizationId,
                    selectedSubs
                )
            );
            //add info pop up
            if (response instanceof AjaxError || !response) {
                this.setRedirectState();
            }
            else {
                await this.RefreshSubmissionList(this.state.editSubmissions.userName);
                this.setState(prev => ({
                    editSubmissions: {
                        ...prev.editSubmissions,
                        isChangeSaved: true
                    }
                }));
            }
        }
    }

    private async RemoveSubmissionFromUser(orgId: number, submissionType: string, submissionYear: number) {
        // Find the submission to remove based on the parameters
        const submissionToRemove = this.state.editSubmissions.submissionData.find(sub =>
            sub.productLine === submissionType &&
            sub.reportingProduct === submissionYear.toString()
        );

        if (!submissionToRemove) {
            console.error('Submission not found to remove');
            return;
        }

        // Find the index of the submission to remove
        const submissionIndex = this.state.editSubmissions.submissionData.findIndex(sub =>
            sub.submissionId === submissionToRemove.submissionId
        );

        if (submissionIndex === -1) {
            console.error('Submission index not found');
            return;
        }

        // Remove the submission from the selected indexes
        const updatedSelectedSubIndexes = this.state.editSubmissions.selectedSubIndexes.filter(index => index !== submissionIndex);

        // Update the state with the new selection
        this.setState({
            editSubmissions: {
                ...this.state.editSubmissions,
                selectedSubIndexes: updatedSelectedSubIndexes
            }
        });

        // Save the changes using the same pattern as SaveSubmissionChange
        const selectedSubs: number[] = updatedSelectedSubIndexes.map(x => {
            return this.state.editSubmissions.submissionData[x] === null ? -1 : this.state.editSubmissions.submissionData[x].submissionId;
        });

        const response = await firstValueFrom(
            UserManagerService.UpdateSubUserEntities$(
                this.props.user,
                this.state.editSubmissions.userName,
                this.state.editOrganization.organizationId,
                selectedSubs
            )
        );

        if (response instanceof AjaxError || !response) {
            this.setRedirectState();
        } else {
            // Refresh the submission list to reflect the changes
            await this.RefreshSubmissionList(this.state.editSubmissions.userName);
            this.setState({
                editSubmissions: {
                    ...this.state.editSubmissions,
                    isChangeSaved: true
                }
            });
        }
    }

    private isSubmissionTouched() {
        if (this.state.editSubmissions.origSelectedSubIndexes.length !== this.state.editSubmissions.selectedSubIndexes.length)
            return true;
        for (var i = 0; i < this.state.editSubmissions.origSelectedSubIndexes.length; i++) {
            let found: boolean = false;
            for (var j = 0; j < this.state.editSubmissions.selectedSubIndexes.length; j++) {
                if (this.state.editSubmissions.origSelectedSubIndexes[i] === this.state.editSubmissions.selectedSubIndexes[j])
                    found = true;
            }
            if (!found)
                return true;
        }
        return false;
    }
    private backToOrgUsersList = () => {
        this.setState({
            editSubmissions: {
                isEditingSubmissions: false,
                userName: "",
                submissionData: [],
                origSelectedSubIndexes: [],
                selectedSubIndexes: [],
                isChangeSaved: false
            }
        });
    }
    private btnClickManageSubmissions = async (userName) => {
        this.setState({
            editSubmissions: {
                ...this.state.editSubmissions,
                userName: userName,
                isEditingSubmissions: true
            }
        });
        this.RefreshSubmissionList(userName);
    }
    private async RefreshSubmissionList(userName) {
        this.setState({ isLoadingAuditorSubmissions: true });
        const subsRetVal: ISubmissionKey[] = await firstValueFrom(
            SubmissionsService.GetSubmissionKeysForOrg$(
                this.props.user,
                this.state.editOrganization.organizationId
            )
        );
        const accessibleSubIds: number[] = await firstValueFrom(
            UserManagerService.GetAccessableSubIds$(this.props.user, userName)
        );
        if (subsRetVal instanceof AjaxError || accessibleSubIds instanceof AjaxError || !subsRetVal || !accessibleSubIds) {
            this.setRedirectState();
        }
        else {
            let indexes: number[] = [];
            let indexesAll: number[] = [];
            let found: boolean = false;
            for (var i = 0; i < subsRetVal.length; i++) {
                indexesAll.push(i);
                for (var j = 0; j < accessibleSubIds.length; j++) {
                    if (accessibleSubIds[j] === subsRetVal[i].submissionId) {
                        found = true;
                        indexes.push(i);
                    }
                }
            }
            this.setState(prev =>({
                editSubmissions: {
                    ...prev.editSubmissions,
                    submissionData: subsRetVal,
                    origSelectedSubIndexes: found ? indexes : indexesAll,
                    selectedSubIndexes: found ? indexes : indexesAll
                },
                isLoadingAuditorSubmissions: false
            }));
        }
    }
    onEditOrganizationFormSubmit = async () => {
        try {
            this.setProcessingState(true);
            const response = await firstValueFrom(
                UserManagerService.AddUserToRoles$(
                    this.props.user,
                    this.state.editOrganization.selectedUser.value,
                    this.state.editOrganization.orgType.toLowerCase(),
                    this.state.editOrganization.selectedRole.value,
                    this.state.editOrganization.organizationId.toString(),
                    "",
                    false
                )
            );
            if (response instanceof AjaxError || !response) {
                this.setRedirectState();
            }
            else {
                await this.RefreshUsersForOrganization(this.state.editOrganization.organizationId);
                this.setState(prev => ({
                    editOrganization: {
                        ...prev.editOrganization,
                        selectedUser: "",
                        selectedRole: ""
                    }
                }));
            }
        } catch (ex) {
        } finally {
            this.setProcessingState(false);
        }
    };

    onChangeSelectUserToEntity(newValue) {
        if (this.state.editOrganization.selectedRole && this.state.editOrganization.selectedRole.value.toLowerCase() === "auditor" && !this.isSelectedUserAuditor(newValue === null ? "" : newValue.value)) {
            this.setState({
                editOrganization: {
                    ...this.state.editOrganization,
                    selectedRole: "",
                    selectedUser: newValue === null ? "" : newValue
                }
            });
        }
        else {
            this.setState({
                editOrganization: {
                    ...this.state.editOrganization,
                    selectedUser: newValue === null ? "" : newValue
                }
            });
        }
    }

    onChangeSelectRoleToEntityUser(newValue) {
        this.setState({
            editOrganization: {
                ...this.state.editOrganization,
                selectedRole: newValue === null ? "" : newValue
            }
        })
    }
    async handleOrgUserRoleChange(tableMeta, newValue) {
        try {
            this.setProcessingState(true);

            this.setState(prev =>({
                editOrganization: {
                    ...prev.editOrganization,
                    currentlySubmittingRowIndex: tableMeta.rowIndex
                }
            }));
            const deleteResp = await firstValueFrom(
                UserManagerService.DeleteUserRole$(
                    this.props.user,
                    tableMeta.rowData[0],
                    this.state.editOrganization.organizationId + "," + this.state.editOrganization.orgType.toLowerCase() + "," + tableMeta.rowData[1]
                )
            );

            if (deleteResp instanceof AjaxError || !deleteResp) {
                this.setRedirectState();
            }
            else {
                const resp = await firstValueFrom(
                    UserManagerService.AddUserToRoles$(
                        this.props.user,
                        tableMeta.rowData[0],
                        this.state.editOrganization.orgType.toLowerCase(),
                        newValue.value,
                        this.state.editOrganization.organizationId.toString(),
                        "",
                        false
                    )
                );

                if (resp instanceof AjaxError || !resp) {
                    this.setRedirectState();
                }
                else {
                    this.setState(prev =>({
                        editOrganization: {
                            ...prev.editOrganization,
                            currentlySubmittingRowIndex: null
                        }
                    }));
                    await this.RefreshUsersForOrganization(this.state.editOrganization.organizationId);
                }
            }
        } catch (ex) {
        } finally {
            this.setProcessingState(false);
        }
    }

    private validateEditOrganizationForm = (values: IEditOrganizationForm): FormikErrors<IEditOrganizationForm> => {
        const errors: FormikErrors<IEditOrganizationForm> = {};

        if (validator.isEmpty(values.selectedUser)) {
            errors.selectedUser = "Required";
        }

        if (validator.isEmpty(values.selectedRole)) {
            errors.selectedRole = "Required";
        }

        return errors;
    };

    private RefreshUsersForOrganization = async (organizationId) => {
        const userRetVal: IOrgUserPayload[] = await firstValueFrom(
            UserManagerService.GetUsersForOrganization$(
                this.props.user,
                organizationId
            )
        );

        if (userRetVal instanceof AjaxError || !userRetVal) {
            this.setRedirectState();
        }
        else {
            let orgUsers = userRetVal.map(item => {
                return item;
            });

            this.setState(prev =>({
                editOrganization: {
                    ...prev.editOrganization,
                    existingUsers: orgUsers
                }
            }));
        }
    }

    private ShowOrgUserDeleteDialog = (userName, roleName) => {
        this.setState({
            events: {
                ...this.state.events,
                deleteOrgUserConfirmDialogOpen: true
            },
            deleteOrgUserDialog: {
                title: "Delete User (" + userName + ")?",
                description: "Are you sure you'd like to delete " + roleName + " role for " + userName + "?",
                user: userName,
                roleInfo: this.state.editOrganization.organizationId + "," + this.state.editOrganization.orgType.toLocaleLowerCase() + "," + roleName
            }
        });
    }

    private DeleteOrgUser = async () => {
        try {
            this.setProcessingState(true);
            const deleteResp = await firstValueFrom(
                UserManagerService.DeleteUserRole$(
                    this.props.user,
                    this.state.deleteOrgUserDialog.user,
                    this.state.deleteOrgUserDialog.roleInfo
                )
            );

            if (deleteResp instanceof AjaxError || !deleteResp) {
                this.setRedirectState();
            }
            else {
                await this.RefreshUsersForOrganization(this.state.editOrganization.organizationId);
                this.CloseDeleteOrgUserConfirmDialog();
            }
        } catch (ex) {
        } finally {
            this.setProcessingState(false);
        }
    }

    private CloseDeleteOrgUserConfirmDialog = () => {
        this.setState({
            events: {
                ...this.state.events,
                deleteOrgUserConfirmDialogOpen: false
            }
        });
    }

    private ShowAllUserDeleteDialog = () => {
        this.setState({
            events: {
                ...this.state.events,
                deleteAllUserConfirmDialogOpen: true
            },
            deleteAllUserDialog: {
                title: "Delete All Users?",
                description: "Are you sure you'd like to delete all users for Organization (" + this.state.editOrganization.organizationName + ")?"
            }
        });
    }

    private DeleteAllOrgUsers = async () => {
        this.setState({
            events: {
                ...this.state.events,
                currentlyDeletingAllUsersForOrg: true,
                deleteAllUserConfirmDialogOpen: false
            }
        });
        try {
            this.setProcessingState(true);
            const deleteResp = await firstValueFrom(
                UserManagerService.DeleteAllOrgUsers$(
                    this.props.user,
                    this.state.editOrganization.organizationId.toString()
                )
            );

            if (deleteResp instanceof AjaxError || !deleteResp) {
                this.setRedirectState();
            }
            else {
                await this.RefreshUsersForOrganization(this.state.editOrganization.organizationId);
                this.setState({
                    events: {
                        ...this.state.events,
                        currentlyDeletingAllUsersForOrg: false
                    }
                });
            }
        } catch (ex) {
        } finally {
            this.setProcessingState(false);
        }
    }
}

// REDUX CONTAINER
const UserListsPageWithState = connect<IGenericUserProps>(
    genericMapStateToProps
)(UsersListView);

// STYLES CONTAINER
const UsersListPage = withStyles(styles)(UserListsPageWithState);

export default UsersListPage;
